import { render, staticRenderFns } from "./BookPanel.vue?vue&type=template&id=2598cda2&scoped=true"
import script from "./BookPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./BookPanel.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BookPanel.vue?vue&type=style&index=0&id=2598cda2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2598cda2",
  null
  
)

export default component.exports